import { ApplePayLineItem } from '../apple-pay-line-item';

export class ApplePayLineItemBuilder {
	private applePayLineItem: ApplePayJSV14.ApplePayLineItem;

	constructor() {
		this.applePayLineItem = new ApplePayLineItem();
	}

	setLabel(label?: string): this {
		this.applePayLineItem.label = label ?? '';
		return this;
	}

	setAmount(amount: string): this {
		this.applePayLineItem.amount = amount ?? '0';
		return this;
	}

	setType(type?: ApplePayJS.ApplePayLineItemType): this {
		this.applePayLineItem.type = type ?? 'final';
		return this;
	}

	setPaymentTiming(paymentTiming: ApplePayJSV14.ApplePayPaymentTiming): this {
		this.applePayLineItem.paymentTiming = paymentTiming;
		return this;
	}

	setDeferredPaymentDate(deferredDate: Date): this {
		this.applePayLineItem.deferredPaymentDate = deferredDate;
		return this;
	}

	getApplePayLineItem(): ApplePayJSV14.ApplePayLineItem {
		return this.applePayLineItem;
	}
}
